export default "__VITE_ASSET__56bdb380__"